import Vue from 'vue'
import Vuex from 'vuex'
import { axios2 as axios } from "@/interceptor/useApi";

Vue.use(Vuex)

export default {
    namespaced: true,
    state: {
        MotivosScrap: []
    },
    mutations: {
        setMotivosScrap(state, payload) {
            state.MotivosScrap = payload
        }
    },
    actions: {
        cargarMotivosScrap: async function ({ commit }) {
            const url = "motivos/scrap?id_cliente=" + localStorage.getItem("idcliente");
            let datos = {id_cliente: localStorage.getItem("idcliente")};
            await axios.get(url)
                .then(response => {
                    let motivoScrapList = [];
                    response.data.data.forEach((element, i) => {
                        motivoScrapList[i] = {
                            value: element.id,
                            text: element.motivo
                        };
                    });
                    commit('setMotivosScrap', motivoScrapList);                 
                })
                .catch(error => {
                    this.errorMessage = error.response.data;
                    console.error("error!", error);
                });
        },
        
        agregarMotivosScrap: async function ({ commit, dispatch }, datos) {
            var url = datos.url;
            const data = {
                id_cliente: localStorage.getItem("idcliente"),
                motivo: datos.motivo,
            };
            let rpta = null;
            await axios
            .post(url, data)
            .then((response) => {
                rpta = response.data.data;
            })
            .catch((error) => {
                this.errorMessage = error.response.data;
                console.error("error!", error);
                dispatch("messageErrorAlert");
            });
            return rpta;
        },
  
    }
}